declare namespace $ {

	type $mol_view__sub_bog_smalljs_playground_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_smalljs_structure__tree_bog_smalljs_playground_2 = $mol_type_enforce<
		ReturnType< $bog_smalljs_playground['files_tree'] >
		,
		ReturnType< $bog_smalljs_structure['tree'] >
	>
	type $bog_smalljs_structure__active_bog_smalljs_playground_3 = $mol_type_enforce<
		ReturnType< $bog_smalljs_playground['active_file'] >
		,
		ReturnType< $bog_smalljs_structure['active'] >
	>
	type $bog_smalljs_structure__pickable_bog_smalljs_playground_4 = $mol_type_enforce<
		boolean
		,
		ReturnType< $bog_smalljs_structure['pickable'] >
	>
	type $bog_smalljs_structure__plain_bog_smalljs_playground_5 = $mol_type_enforce<
		boolean
		,
		ReturnType< $bog_smalljs_structure['plain'] >
	>
	type $bog_smalljs_structure__file_bog_smalljs_playground_6 = $mol_type_enforce<
		ReturnType< $bog_smalljs_playground['file_pick'] >
		,
		ReturnType< $bog_smalljs_structure['file'] >
	>
	type $mol_view__sub_bog_smalljs_playground_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_playground_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_smalljs_playground_9 = $mol_type_enforce<
		ReturnType< $bog_smalljs_playground['show_tree'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_smalljs_playground_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_bog_smalljs_playground_11 = $mol_type_enforce<
		ReturnType< $bog_smalljs_playground['show_ts'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_smalljs_playground_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_bog_smalljs_playground_13 = $mol_type_enforce<
		ReturnType< $bog_smalljs_playground['show_css'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_smalljs_playground_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_smalljs_playground_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_playground_16 = $mol_type_enforce<
		ReturnType< $bog_smalljs_playground['sample_options'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pick__hint_bog_smalljs_playground_17 = $mol_type_enforce<
		ReturnType< $bog_smalljs_playground['samples_hint'] >
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__align_bog_smalljs_playground_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['align'] >
	>
	type $mol_pick__trigger_content_bog_smalljs_playground_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_bog_smalljs_playground_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_button_minor__hint_bog_smalljs_playground_21 = $mol_type_enforce<
		ReturnType< $bog_smalljs_playground['layout_title'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_smalljs_playground_22 = $mol_type_enforce<
		ReturnType< $bog_smalljs_playground['layout_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_smalljs_playground_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_smalljs_playground_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_bog_smalljs_playground_25 = $mol_type_enforce<
		ReturnType< $bog_smalljs_playground['share_title'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_smalljs_playground_26 = $mol_type_enforce<
		ReturnType< $bog_smalljs_playground['share'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_smalljs_playground_27 = $mol_type_enforce<
		ReturnType< $bog_smalljs_playground['share_content'] >
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_bog_smalljs_playground_28 = $mol_type_enforce<
		ReturnType< $bog_smalljs_playground['reset_hint'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_smalljs_playground_29 = $mol_type_enforce<
		ReturnType< $bog_smalljs_playground['reset'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_smalljs_playground_30 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_smalljs_playground_31 = $mol_type_enforce<
		ReturnType< $bog_smalljs_playground['tabs_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_playground_32 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_textarea__value_bog_smalljs_playground_33 = $mol_type_enforce<
		ReturnType< $bog_smalljs_playground['draft'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__hint_bog_smalljs_playground_34 = $mol_type_enforce<
		ReturnType< $bog_smalljs_playground['editor_hint'] >
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_view__sub_bog_smalljs_playground_35 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_textarea__value_bog_smalljs_playground_36 = $mol_type_enforce<
		ReturnType< $bog_smalljs_playground['ts_draft'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__hint_bog_smalljs_playground_37 = $mol_type_enforce<
		ReturnType< $bog_smalljs_playground['editor_hint_ts'] >
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_view__sub_bog_smalljs_playground_38 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_textarea__value_bog_smalljs_playground_39 = $mol_type_enforce<
		ReturnType< $bog_smalljs_playground['css_draft'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__hint_bog_smalljs_playground_40 = $mol_type_enforce<
		ReturnType< $bog_smalljs_playground['editor_hint_css'] >
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_view__sub_bog_smalljs_playground_41 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_playground_42 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_smalljs_playground_43 = $mol_type_enforce<
		ReturnType< $bog_smalljs_playground['log_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_smalljs_playground_44 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_smalljs_playground_45 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_playground_46 = $mol_type_enforce<
		ReturnType< $bog_smalljs_playground['preview_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_playground_47 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_bog_smalljs_playground_48 = $mol_type_enforce<
		ReturnType< $bog_smalljs_playground['log_clear_hint'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_smalljs_playground_49 = $mol_type_enforce<
		ReturnType< $bog_smalljs_playground['log_clear'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_smalljs_playground_50 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_smalljs_playground_51 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_playground_52 = $mol_type_enforce<
		ReturnType< $bog_smalljs_playground['log_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__attr_bog_smalljs_playground_53 = $mol_type_enforce<
		({ 
			'bog_smalljs_pg_log_shown': ReturnType< $bog_smalljs_playground['log_shown'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_bog_smalljs_playground_54 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_playground_55 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_smalljs_playground_56 = $mol_type_enforce<
		ReturnType< $bog_smalljs_playground['sample_pick'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_smalljs_playground_57 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__attr_bog_smalljs_playground_58 = $mol_type_enforce<
		({ 
			'bog_smalljs_pg_level': ReturnType< $bog_smalljs_playground['log_level'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_bog_smalljs_playground_59 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_smalljs_playground extends $mol_view {
		Files_label( ): $mol_view
		Files_tree( ): $bog_smalljs_structure
		Files_note( ): $mol_view
		Files( ): $mol_view
		show_tree( next?: any ): any
		tree_tab_label( ): string
		Tree_tab( ): $mol_button_minor
		show_ts( next?: any ): any
		ts_tab_label( ): string
		Ts_tab( ): $mol_button_minor
		show_css( next?: any ): any
		css_tab_label( ): string
		Css_tab( ): $mol_button_minor
		Tabs_gap( ): $mol_view
		samples_hint( ): string
		samples_label( ): string
		Samples_label( ): $mol_view
		Samples_chevron( ): $mol_icon_chevron_down
		sample_options( ): readonly(any)[]
		Samples_menu( ): $mol_view
		Samples( ): $mol_pick
		layout_title( ): string
		layout_toggle( next?: any ): any
		Layout_icon( ): $mol_icon_view_agenda
		Layout_toggle( ): $mol_button_minor
		share_title( ): string
		share( next?: any ): any
		Share_icon( ): $mol_icon_share_variant_outline
		Share_done_icon( ): $mol_icon_check
		share_done_label( ): string
		Share_done_label( ): $mol_view
		share_content( ): readonly(any)[]
		Share( ): $mol_button_minor
		reset_hint( ): string
		reset( next?: any ): any
		Reset_icon( ): $mol_icon_restore
		Reset( ): $mol_button_minor
		tabs_content( ): readonly(any)[]
		Tabs( ): $mol_view
		Editor_tree_label( ): $mol_view
		Editor( ): $mol_textarea
		Editor_ts_label( ): $mol_view
		editor_hint_ts( ): string
		Editor_ts( ): $mol_textarea
		Editor_css_label( ): $mol_view
		editor_hint_css( ): string
		Editor_css( ): $mol_textarea
		Editors( ): $mol_view
		Editor_pane( ): $mol_view
		preview_label_text( ): string
		Preview_gap( ): $mol_view
		log_toggle( next?: any ): any
		log_toggle_label( ): string
		Log_toggle( ): $mol_button_minor
		Preview_label( ): $mol_view
		preview_content( ): readonly(any)[]
		Preview( ): $mol_view
		log_shown( ): boolean
		log_title_text( ): string
		Log_title( ): $mol_view
		Log_gap( ): $mol_view
		log_clear_hint( ): string
		log_clear( next?: any ): any
		Log_clear( ): $mol_button_minor
		Log_head( ): $mol_view
		log_rows( ): readonly(any)[]
		Log_list( ): $mol_view
		Log( ): $mol_view
		Preview_pane( ): $mol_view
		tab( ): string
		draft( next?: string ): string
		ts_draft( next?: string ): string
		css_draft( next?: string ): string
		editor_hint( ): string
		seed_tree( ): string
		seed_ts( ): string
		seed_css( ): string
		store_scope( ): string
		sample_title( id: any): string
		sample_pick( id: any, next?: any ): any
		sample_hello_title( ): string
		sample_counter_title( ): string
		sample_fetch_title( ): string
		sample_args_title( ): string
		sample_routing_title( ): string
		sample_state_title( ): string
		sample_login_title( ): string
		Sample_option( id: any): $mol_button_minor
		shared( ): boolean
		share_hint( ): string
		share_done_hint( ): string
		editors_mode( next?: string ): string
		layout_hint( ): string
		layout_hint_tabs( ): string
		files_showed( ): boolean
		files_tree( ): string
		active_file( ): string
		file_pick( next?: any ): any
		files_title( ): string
		files_note( ): string
		attr( ): ({ 
			'bog_smalljs_pg_tab': ReturnType< $bog_smalljs_playground['tab'] >,
			'bog_smalljs_pg_editors': ReturnType< $bog_smalljs_playground['editors_mode'] >,
			'bog_smalljs_pg_files': ReturnType< $bog_smalljs_playground['files_showed'] >,
			'bog_smalljs_pg_shared': ReturnType< $bog_smalljs_playground['shared'] >,
		}) 
		sub( ): readonly(any)[]
		log_open( next?: boolean ): boolean
		log_text( id: any): string
		log_level( id: any): string
		Log_row( id: any): $mol_view
	}
	
}

//# sourceMappingURL=playground.view.tree.d.ts.map